import mutations from './mutations'
import getters from './getters'
import actions from './actions'

const state = {
  sipConfig: {},
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
